/**
 * Direct Checkout for Ace Pillow.
 *
 * Bypasses Kaching's Add-to-Cart handler entirely. When the user clicks the
 * Add-to-Cart button, we read which Kaching deal bar is currently selected
 * (by inspecting which radio is `:checked`) and navigate straight to the
 * matching Shopify cart permalink — which Shopify then redirects to checkout.
 *
 * Deal-bar → URL mapping (Ace Pillow):
 *   lEms (1 Pillow)  → 1 pillow + 1 mask
 *   Rk_L (2 Pillows) → 2 pillows + 2 masks
 *
 * Kaching's bundle UI keeps working visually; we only short-circuit the
 * actual add-to-cart action.
 */
(function () {
  // Only run on the Ace Pillow product page.
  if (location.pathname.indexOf('/products/ace-pillow') === -1) return;

  var PILLOW = '48391174652145';
  var MASK   = '48395169038577';

  var DEAL_URL = {
    'lEms': '/cart/' + PILLOW + ':1,' + MASK + ':1',  // 1 pillow + 1 mask
    'Rk_L': '/cart/' + PILLOW + ':2,' + MASK + ':2'   // 2 pillows + 2 masks
  };

  // Fallback: the preselected deal at page load is Rk_L (2 pillows).
  var DEFAULT_URL = DEAL_URL['Rk_L'];

  function getSelectedDealUrl() {
    var checked = document.querySelector('.kaching-bundles__bar input[type="radio"]:checked');
    if (checked) {
      var bar = checked.closest && checked.closest('.kaching-bundles__bar');
      if (bar) {
        var dealId = bar.getAttribute('data-deal-bar-id');
        if (dealId && DEAL_URL[dealId]) return DEAL_URL[dealId];
        // Fallback: detect quantity from the selected bar's text.
        if (/2\s*Pillow/i.test(bar.textContent)) return DEAL_URL['Rk_L'];
        return DEAL_URL['lEms'];
      }
    }
    return DEFAULT_URL;
  }

  function takeOver(e) {
    // Stop EVERYTHING — Kaching's handlers, theme's handlers, the form submit.
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();
    window.location = getSelectedDealUrl();
  }

  // Capture phase = we run BEFORE any bubble-phase listener Kaching/theme
  // attached. `stopImmediatePropagation()` prevents the other capture listeners
  // from running too.
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest('.product-form__submit, button[name="add"][type="submit"], button.product-form__submit');
    if (!btn) return;
    takeOver(e);
  }, true);

  // Catch form submits triggered by Enter key or any programmatic .submit().
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    if (!form.closest || !form.closest('product-form')) return;
    takeOver(e);
  }, true);
})();
